import { createBaseAxiosClient } from '@config/apiConfiguration';
import { AxiosRestApplicationClient as DirectMoneyApplicationClient } from '@g2-shared/api-client/generated/direct-money-gateway-app';
import { AxiosRestApplicationClient as OnboardingApplicationClient } from '@g2-shared/api-client/generated/onboarding-app';
import {
  ConsoleLoggerService,
  generatedClientResponseInterceptor,
  ILoggingService,
  INotificationService,
  NotificationsService,
  TranslationAdapter,
} from '@g2-shared/common';
import { en } from '@locales/en';
import { createContext, ReactElement, useContext } from 'react';

const { VITE_APP_GATEWAY_BASE_URL, VITE_APP_DIRECT_MONEY_GATEWAY_BASE_URL } = import.meta.env;

export const OnboardingApiClient = new OnboardingApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  createBaseAxiosClient(VITE_APP_GATEWAY_BASE_URL, generatedClientResponseInterceptor)
);

const DirectMoneyApiClient = new DirectMoneyApplicationClient(
  VITE_APP_DIRECT_MONEY_GATEWAY_BASE_URL,
  createBaseAxiosClient(VITE_APP_DIRECT_MONEY_GATEWAY_BASE_URL)
);

interface IGlobalDIContext {
  NotificationService: () => INotificationService;
  LoggingService: ILoggingService;
  TranslationAdapter: typeof TranslationAdapter<typeof en>;
  OnboardingApiClient: OnboardingApplicationClient;
  DirectMoneyApiClient: DirectMoneyApplicationClient;
}

export const initialState: IGlobalDIContext = {
  NotificationService: NotificationsService,
  LoggingService: ConsoleLoggerService(),
  TranslationAdapter,
  OnboardingApiClient,
  DirectMoneyApiClient,
};

export const GlobalDIContext = createContext<IGlobalDIContext>(initialState);

export const useGlobalDIContext = (): IGlobalDIContext => {
  const context = useContext(GlobalDIContext);

  return context;
};
/* ----------- */
/*    Props    */

/* ----------- */
interface Props {
  children: ReactElement;
}

export const GlobalDIContextProvider: React.FC<Props> = ({ children }) => (
  <GlobalDIContext.Provider value={initialState}>{children}</GlobalDIContext.Provider>
);
